import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ComboProductsComponent} from './combo-products.component';
import {AuthGuard} from '@app/shared';
import {AddComboProductsComponent} from '@app/modules/combo-products/add-combo-products/add-combo-products.component';
import {
  ComboProductsListComponent
} from '@app/modules/combo-products/combo-products-list/combo-products-list.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {path: '', component: ComboProductsComponent},
      {
        path: 'add-combo-products',
        loadComponent: () => AddComboProductsComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/add-combo-products'}
      },
      {
        path: 'combo-products-list',
        loadComponent: () => ComboProductsListComponent,
        canActivate: [AuthGuard],
        data: {level: 2, path: '/combo-products-list'}
      },


    ],
    runGuardsAndResolvers: 'always',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ComboProductsRoutingModule {
}


